// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__aZZSU","boxTitle":"Qualiphy_boxTitle__EkEne","box":"Qualiphy_box__2hg6H","toggleWrap":"Qualiphy_toggleWrap__3rkUv"};